import parser from 'utils/parser'
import { sFetchUser, sCheckTokens } from 'apis/uc'
import { TOKENS, THIRD_ACCESS_TOKEN, THIRD_REFRESH_TOKEN, LOGIN_USER_INFO_KEY } from 'utils/constants'
import { SessionStorage, LocalStorage } from 'utils/config'
import { getParameterByName } from 'utils/helpers'
import edmodoUser from 'utils/edmodoUser'

const userInfoKey = window.localStorage['L-ND-RES-LOGIN_USER_INFO_KEY']
const userInfo = userInfoKey ? JSON.parse(userInfoKey) : ''
const user_id = userInfo ? userInfo.value.user_id : ''
const user_name = userInfo ? userInfo.value.user_name : ''
export default function (router, store) {
  // router hooks
  router.beforeEach(async (to, from, next) => {
    const __mac = getParameterByName('__mac')
    const __third_access_token = getParameterByName('__third_access_token')
    const __third_refresh_token = getParameterByName('__third_refresh_token')
    if (__third_access_token) LocalStorage.set(THIRD_ACCESS_TOKEN, __third_access_token)
    if (__third_refresh_token) LocalStorage.set(THIRD_REFRESH_TOKEN, __third_refresh_token)
    if (to.matched.some(record => record.meta.auth)) {
      if (__mac) {
        const decAuth = window.atob(__mac)
        const authorization = parser.parseToken(decAuth) || {}
        Object.assign(authorization, {
          'request_uri': window.location.pathname,
          'host': window.location.host,
          'http_method': 'GET'
        })
        let loginToken
        let userInfo
        sCheckTokens(authorization).then(res => {
          loginToken = res
          return sFetchUser(res.user_id, res)
        }).then(res => {
          userInfo = res
          store.dispatch('user/setLoginUserInfo', userInfo)
          store.dispatch('user/setTokens', loginToken)
          LocalStorage.set(LOGIN_USER_INFO_KEY, userInfo)
          LocalStorage.set(TOKENS, loginToken)
        }).catch(err => {
          console.log(err)
          next()
        }).finally(() => {
          if (window.opener) {
            window.opener.postMessage('login success', '*')
          } else {
            window.location.search = ''
          }
          next()
        })
      } else {
        var _TOKENS = SessionStorage.get(TOKENS)
        if (!_TOKENS) {
          const localtoken = LocalStorage.get(TOKENS)
          if (localtoken) {
            const userInfo = LocalStorage.get(LOGIN_USER_INFO_KEY)
            store.dispatch('user/setLoginUserInfo', userInfo)
            store.dispatch('user/setTokens', localtoken)
            next()
          } else {
            next()
          }
        } else {
          next()
        }
      }
    } else {
      next()
    }
    const edmodo_user = await edmodoUser(__third_access_token)
    store.dispatch('home/setEdmodoUser', edmodo_user)
    const { type: user_type } = edmodo_user
    window.gtag('set', { user_type })
    if (window.gtag) {
      const { leave_id } = from.meta
      const leaveParams = {
        event_category: from.name,
        event_label: 'leave',
        value: Math.round(performance.now()),
        user_id,
        user_name
      }
      if (leave_id) {
        window.gtag('event', leave_id, {
          ...leaveParams,
          event_callback: () => {
            console.log(leaveParams)
          }
        })
      }
    }
  })

  router.afterEach(async (to, from) => {
    if (document.activeElement && document.activeElement.nodeName !== 'BODY') {
      document.activeElement.blur()
    }
    // const { type: user_type } = await edmodoUser()
    if (window.gtag) {
      const { enter_id, leave_id } = to.meta
      const { product_id } = to.params
      const enterParams = {
        event_category: to.name,
        event_label: 'enter',
        user_id,
        user_name
      }
      const leaveParams = {
        event_category: to.name,
        event_label: 'leave',
        value: Math.round(performance.now()),
        user_id,
        user_name
      }
      if (product_id) window.gtag('set', { product_id })
      if (enter_id) {
        window.gtag('event', enter_id, {
          ...enterParams,
          event_callback: () => {
            console.log(enterParams)
          }
        })
      }
      if (leave_id) {
        window.onbeforeunload = e => {
          window.gtag('event', leave_id, {
            ...leaveParams,
            event_callback: () => {
              console.log(leaveParams)
            }
          })
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/application/router/index.js